import { Component, OnInit } from '@angular/core';
import { BonusService } from '@service/bonus.service';
import { BonusLevel } from '@model/bonus-level';
import { ScrollService } from '@service/scroll.service';
import { ProfileStateComponent } from '@component/profile/profile-state.component';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogComponent } from '@modal/message-dialog/message-dialog.component';
import { ToastService } from '@service/toast/toast.service';
import { messages } from '@configuration/messages';
import moment from 'moment';
import { IntroductionDialogComponent } from '@modal/introduction-dialog/introduction-dialog.component';
import { environment } from '@environments/environment';
import { StateService } from '@service/state.service';
import { MobileService } from '@service/mobile.service';
import { SliderImagesService } from '@service/slider-images.service';

@Component({
  selector: 'app-profile-boni',
  templateUrl: './profile-boni.component.html',
  styleUrls: ['./profile-boni.component.scss'],
})
export class ProfileBoniComponent extends ProfileStateComponent implements OnInit {
  public environment = environment;

  // make it public for the template
  public moment = moment;

  public levels: Array<BonusLevel> = null;
  public nextLevel: BonusLevel = null;
  public currentLevel: BonusLevel = null;

  public loading: boolean = false;

  public hasSliderImages: boolean = false;

  constructor(
    private BonusService: BonusService,
    public ScrollService: ScrollService,
    private MatDialog: MatDialog,
    private ToastService: ToastService,
    public StateService: StateService,
    public MobileService: MobileService,
    public sliderImagesService: SliderImagesService,
  ) {
    super(ScrollService);
  }

  public ngOnInit() {
    super.ngOnInit();

    this.loading = true;

    let promises = [
      this.BonusService.getNext().then((level: BonusLevel) => {
        this.nextLevel = level;
      }),

      this.BonusService.getCurrent().then((level: BonusLevel) => {
        this.currentLevel = level;
      }),

      this.BonusService.getAll().then((levels: Array<BonusLevel>) => {
        this.levels = levels;
      }),

      // this.bonusService.getBonusHistory()
      // .then((history:BonusLevel[])=>{
      //   this.bonusHistory = history
      //   if (this.bonusHistory && this.bonusHistory.length) {
      //     this.currentLevel = this.bonusHistory[0]
      //   }
      // }),

      // this.bonusService.getRulesHistory()
      // .then((history:BonusRule[])=>{
      //   this.complete = history.length
      //   for (const rule of history) {
      //     rule.completed = true
      //     this.bonusRules.push(rule)
      //   }
      // }),

      // this.bonusService.getRulesTodo()
      // .then((todo:BonusRule[])=>{
      //   this.bonusRules = this.bonusRules.concat(todo)
      // })
    ];

    Promise.all(promises).finally(() => {
      this.loading = false;
    });

    this.sliderImagesService.hasSliderImages$.subscribe((hasImages: boolean) => {
      this.hasSliderImages = hasImages;
    });

    this.sliderImagesService.checkHasSliderImages('profile');
  }

  public redeemBonus(bonus) {
    let text =
      'Bonus einlösen! <br> Schreibe uns hier deine E-Mail Adresse und vollständige Anschrift, damit wir deinen Bonus versenden können.';

    if (bonus.redeem_message)
      text += '<br><br>Hier unsere Nachricht für diesen Bonus an dich:<br>' + bonus.redeem_message;

    const config = {
      title: 'Bonus einlösen',
      text,
    };
    const dialogRef = this.MatDialog.open(MessageDialogComponent, {
      data: config,
      disableClose: true,
      panelClass: MessageDialogComponent.cssClass,
    });

    // ask for user message
    dialogRef.afterClosed().subscribe((result) => {
      if (result.decision != 'send') return;

      this.loading = true;

      // redeem
      this.BonusService.redeemBonus(result.message, bonus.pivot.bonus_level_id).then((response) => {
        this.loading = false;
        bonus.pivot.redeemed = 1;
        bonus.pivot.redeemed_at = new Date();
        this.ToastService.showSuccess(messages.redeemBonusSuccess);
      });
    });
  }

  public openTodoDialog() {
    const config = {};
    const dialogRef = this.MatDialog.open(IntroductionDialogComponent, {
      data: config,
      disableClose: false,
      width: '100vw',
      maxWidth: '100vw',
      height: '100vh',
      panelClass: IntroductionDialogComponent.cssClass,
    })
      .afterClosed()
      .subscribe(() => {
        this.ScrollService.scrollToTop();
      });
  }
}
